import { ZERO } from '@emberswap/emberswap-sdk2/dist/constants'
import { Percent } from '@emberswap/emberswap-sdk2/dist/entities'
import { FC, useCallback, useMemo } from 'react'

import { warningSeverity } from '../../functions/trade/warningSeverity'
import { Button } from '../Button'
import { Checker } from '../Checker'
import { Loader } from '../Loader'
import { useTrade } from '../TradeProvider'

export const SButton: FC<{
  recipient:string | undefined
  userExpertMode: boolean
  recipientActive: boolean
  setOpen(open: boolean): void
  userSlippageTolerance: string
  slippageToleranceType: 'auto' | 'custom'
}> = ({
  recipient,
  userExpertMode,
  recipientActive,
  userSlippageTolerance,
  slippageToleranceType,
  setOpen,
}) => {
  const { isLoading: isLoadingTrade, trade, route } = useTrade()

  const swapSlippage = useMemo(() => {
    if (userSlippageTolerance && slippageToleranceType !== 'auto') {
      return new Percent(Number(userSlippageTolerance) * 100, 10_000)
    } else return new Percent(100, 10_000) // 1%
  }, [slippageToleranceType, userSlippageTolerance])

  const priceImpactSeverity = useMemo(() => warningSeverity(trade?.priceImpact), [trade])
  const priceImpactTooHigh = priceImpactSeverity > 3 && !userExpertMode

  const onClick = useCallback(() => {
    setOpen(true)
  }, [setOpen])

  return (
    <Checker.Custom
      showGuardIfTrue={!route}
      guard={
        <Button color="red" variant="outlined" fullWidth disabled size="md">
          No trade found
        </Button>
      }
    >
      <Button
        testdata-id="swap-button"
        fullWidth
        onClick={onClick}
        disabled={
          (recipientActive && userExpertMode && !recipient) ||
          priceImpactTooHigh ||
          trade?.minimumAmountOut(swapSlippage)?.equalTo(ZERO) ||
          Boolean(!trade && priceImpactSeverity > 2 && !userExpertMode)
        }
        size="md"
        color={priceImpactTooHigh || priceImpactSeverity > 2 ? 'red' : 'gradient'}
        variant="outlined"
        {...(Boolean(!trade && priceImpactSeverity > 2 && !userExpertMode) && {
          title: 'Enable expert mode to swap with high price impact',
        })}
      >
        {isLoadingTrade ? (
          <Loader.Dots>Finding Best Price</Loader.Dots>
        ) : priceImpactTooHigh ? (
          'High Price Impact'
        ) : trade && priceImpactSeverity > 2 ? (
          'Swap Anyway'
        ) : (
          'Swap'
        )}
      </Button>
    </Checker.Custom>
  )
}
